import { memo, useCallback, useEffect,  useState } from 'react';
import { Col, Container, Row, Stack } from 'react-bootstrap';
import {  BzSlider } from '../../components';
import { BEST5_INDEX, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { getKeystats } from '../../redux/actions/marketOverview';
import { useDispatch, useSelector } from 'react-redux';
import { getWfhBestFiveLastTick } from '../../redux/actions/wfh';
import { useWFHMessages } from '../../hooks';
import { sendBestFiveRequest } from '../../apis/web_socket';


const IndicesKeyStats = () => {

    const dispatch = useDispatch();

    const scripOverviewData = useSelector(state => state.marketOverview.scripOverviewData);

    const [arrKeyStatsData, setArrKeyStatsData] = useState([]);

    useEffect(() => {
        dispatch(getKeystats());
        return () => {
            sendBestFiveRequest({ exchangeId: scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false });
        };
    }, []);

    const handleMarketDepthGridRowData = useCallback((arrDetails) => {
        if (scripOverviewData?.length > 0 && arrDetails?.length > 0) {
            if (scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === arrDetails[BEST5_INDEX.SEGMENT_ID]) {
                //By HiralK : 06-09-2023 : For Price optimization - Start	    
                arrDetails[BEST5_INDEX.VALUE] = arrDetails[BEST5_INDEX.VOLUME] * arrDetails[BEST5_INDEX.AVG_TRADED_PRICE];
                arrDetails[BEST5_INDEX.OPEN_PRICE] = (arrDetails[BEST5_INDEX.OPEN_PRICE]);//.toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                arrDetails[BEST5_INDEX.CLOSE_PRICE] = (arrDetails[BEST5_INDEX.CLOSE_PRICE]);//.toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                arrDetails[BEST5_INDEX.HIGH_PRICE] = (arrDetails[BEST5_INDEX.HIGH_PRICE]);//.toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                arrDetails[BEST5_INDEX.LOW_PRICE] = (arrDetails[BEST5_INDEX.LOW_PRICE]);//.toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                setArrKeyStatsData([...arrDetails]);
                //By HiralK : 06-09-2023 : For Price optimization - End
            } else { }
        }
        else { }
    }, [scripOverviewData]);

    useWFHMessages('bestfive', (e) => {
        handleMarketDepthGridRowData([...e.detail]);
    });

    useEffect(() => {
        const objBestFiveLastTick = dispatch(getWfhBestFiveLastTick());
        if (scripOverviewData?.length) {
            if (Object?.keys(objBestFiveLastTick)?.length > 0) {
                const arrLastTickDepthData = objBestFiveLastTick[scripOverviewData[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                if (arrLastTickDepthData?.length > 0) {
                    handleMarketDepthGridRowData(arrLastTickDepthData);
                } else { }
            } else { }

            sendBestFiveRequest({ exchangeId: scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN] });
        }
    }, [dispatch, handleMarketDepthGridRowData, scripOverviewData]);

    
    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0 mt-3'>
                    <Col md={5} className='mrgauto'>
                        <div className='scripoverview-fieldset'>                            
                            <div className='scripoverview-legend'>KEY STATS</div>
                            <Row className='g-0 mt-3'>
                                <Col md={4} className='d-flex flex-column justify-content-start align-items-start'>
                                    <div className='font-regular font-size2 color-subtext'>Open</div>
                                    <div className='font-medium font-size2 color-text'>{arrKeyStatsData?.[BEST5_INDEX.OPEN_PRICE]?.length> 0? arrKeyStatsData?.[BEST5_INDEX.OPEN_PRICE] : "-" }</div>
                                </Col>
                                <Col md={4} className='d-flex flex-column justify-content-center align-items-center'>
                                    <div className='font-regular font-size2 color-subtext'>Close</div>                                
                                    <div className='font-medium font-size2 color-text'>{arrKeyStatsData?.[BEST5_INDEX.CLOSE_PRICE]?.length> 0? arrKeyStatsData?.[BEST5_INDEX.CLOSE_PRICE] : "-"}</div>
                                </Col>
                                <Col md={4} className='d-flex flex-column justify-content-end align-items-end'>
                                    <div className='font-regular font-size2 color-subtext'>Daily Price Range</div>
                                    <div className='font-medium font-size2 text-nowrap color-text'>{arrKeyStatsData?.[BEST5_INDEX.LOW_PRICE]}-{arrKeyStatsData?.[BEST5_INDEX.HIGH_PRICE]}</div>
                                </Col>
                            </Row>
                            <Row className='g-0 mt-4 justify-content-start align-items-start'>
                                <Col>
                                    <Stack direction='horizontal' className='d-flex justify-content-between mb-2'>
                                        <div className='font-regular font-size2 color-subtext'>Today Low</div>
                                        <div className='font-regular font-size2 color-subtext'>Today High</div>
                                    </Stack>
                                    <BzSlider min={arrKeyStatsData?.[BEST5_INDEX.LOW_PRICE]} max={arrKeyStatsData?.[BEST5_INDEX.HIGH_PRICE]} value={arrKeyStatsData?.[BEST5_INDEX.LAST_TRADE_PRICE]} />
                                    <Stack direction='horizontal' className='d-flex justify-content-between mt-2'>
                                        <div className='font-medium font-size2 color-text'>{arrKeyStatsData?.[BEST5_INDEX.LOW_PRICE]}</div>
                                        <div className='font-medium font-size2 color-text'>{arrKeyStatsData?.[BEST5_INDEX.HIGH_PRICE]}</div>
                                    </Stack>
                                </Col>
                            </Row>                            
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default memo(IndicesKeyStats);